import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./shared/components/splash/splash.component').then((m) => m.SplashComponent),
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.routing').then((m) => m.routes),
  },
  {
    path: 'tabs',
    loadChildren: () => import('./modules/tabs/tabs.routing').then((m) => m.routes),
  },
  {
    path: 'frontdesk',
    loadChildren: () => import('./modules/frontdesk/tabs/tabs.routing').then((m) => m.routes),
  },
];
